import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    permitTypes: [],
    allPermitTypes: [],
    filters: {
      order_by: 'name',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async addType({ commit }, { payload }) {
      const company = await this.$axios.post(`${baseURLv1}/permit/`, payload);
      commit('add', ['permitTypes', company.data.data]);
    },

    async editType({ commit }, { type, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/permit/${id}/`, type);

      commit('update', ['permitTypes', { id, payload: response.data.data }]);
    },

    async getTypeDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/${id}/`);

      return response.data.data;
    },

    async deleteType({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/permit/${id}/`);

      commit('remove', ['permitTypes', id]);
      return response.data.data;
    },

    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/permit/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['permitTypes', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
    async loadAllPermitTypes({ _, commit }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/`, {
        params: {
          page_size: 1000,
        },
      });

      commit('set', ['allPermitTypes', response.data.data]);
    },
  },
  getters: {
    selectPermitTypesOptions: (state) => [...state.allPermitTypes].sort((a, b) => a.name.localeCompare(b.name)),
    selectCaseAssessmentOptions: (state) => state.allPermitTypes.filter((el) => el.case_assessment).sort((a, b) => a.name.localeCompare(b.name)),
    selectCaseAssessmentOptionsAreEmpty: (state) => state.allPermitTypes.length === 0,
  },
};
